import React, { ChangeEvent } from 'react';
import {
  Dropdown,
  MenuItem,
  FormLabel,
  FormController,
} from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { isUserAllowedToViewAllPurchases } from '../../../utils/policy-utils';
import { IPHRequest } from '../../../models/purchase-history';

export interface IPurchaseSelectDropdown {
  customerRole: string;
  customerType: string;
}

/**
 *
 * @returns Purchaser Select Dropdown Element
 */
export const PurchaserSelect = ({
  customerRole,
  customerType,
}: IPurchaseSelectDropdown) => {
  const { username } = useThdCustomer();
  const { pHRequest, setPHRequest, rules } = usePurchaseHistoryContext();

  const permissionCheck: boolean = isUserAllowedToViewAllPurchases(
    customerRole,
    customerType,
    rules,
  );

  const PurchaserItems: { [key in string]: string } = {
    allOrders: 'Everyone',
    myOrders: `${username ?? ''} (Just Me)`,
  };

  if (customerType === 'b2b' && permissionCheck) {
    return (
      <FormController fullWidth data-testid="purchaser-select-dropdown">
        <FormLabel>View Purchases Made By</FormLabel>
        <Dropdown
          style={{ width: '214px' }}
          label="View Purchases Made By"
          value={pHRequest.resultsFilter}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setPHRequest((prevState: IPHRequest) => {
              return {
                ...prevState,
                resultsFilter: event.target.value,
              };
            });
          }}
        >
          {Object.keys(PurchaserItems).map((key: string) => {
            return (
              <MenuItem key={key} value={key}>
                {PurchaserItems[key]}
              </MenuItem>
            );
          })}
        </Dropdown>
      </FormController>
    );
  }
  return null;
};
